import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack, Checkbox, FormControlLabel, Tooltip } from "@mui/material";
const moment = require("moment");
import { useToast } from "../comman/CustomMessages";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ViewInvoiceBroker(props) {
  console.log("viewInvoiceBrokerDetail", props);

  const { open, setViewInvoiceBrokerModel, viewInvoiceBrokerDetail } = props;

  var viewInvoiceStatus = viewInvoiceBrokerDetail.status;
  const viewInvoicePeriod = viewInvoiceBrokerDetail.period;
  const viewInvoiceInvoiceobj = viewInvoiceBrokerDetail.Invoiceobj;
  var viewInvoiceDataInvoiceStatement =
    viewInvoiceBrokerDetail.dataInvoiceStatement &&
    viewInvoiceBrokerDetail.dataInvoiceStatement?.length > 0 &&
    viewInvoiceBrokerDetail.dataInvoiceStatement.filter(
      (row) => row.StatusID == viewInvoiceStatus
    );

    var couuntAdminCreated = 0;

  if (viewInvoiceStatus == 4) {
    const statmentIdsArray = viewInvoicePeriod.statmentIds
      .split(",")
      .map(Number);
    const statusIdArray = viewInvoicePeriod.StatusId.split(",").map(Number);

    const filteredData = statmentIdsArray.map((id, index) => ({
      statmentId: id,
      StatusId: statusIdArray[index],
    }));

    const resultInvoiceClosed = filteredData.filter(
      (item) => item.StatusId === 4
    );
    const statmentIds =
      resultInvoiceClosed &&
      resultInvoiceClosed?.length > 0 &&
      resultInvoiceClosed.map((item) => item.statmentId);
    viewInvoiceDataInvoiceStatement =
      viewInvoiceBrokerDetail.dataInvoiceStatement &&
      viewInvoiceBrokerDetail.dataInvoiceStatement?.length > 0 &&
      viewInvoiceBrokerDetail.dataInvoiceStatement.filter((item) =>
        statmentIds.includes(item.BillingStatementID)
      );
      if(statmentIds && statmentIds.length > 0){
        couuntAdminCreated = statmentIds.filter(num => num == 0).length;
      }
  }

  if (viewInvoiceStatus == 3) {
    const statmentIdsArray = viewInvoicePeriod.statmentIds
      .split(",")
      .map(Number);
    const statusIdArray = viewInvoicePeriod.StatusId.split(",").map(Number);

    const filteredData = statmentIdsArray.map((id, index) => ({
      statmentId: id,
      StatusId: statusIdArray[index],
    }));

    const resultInvoiceClosed = filteredData.filter(
      (item) => item.StatusId === 3
    );
    const statmentIds =
      resultInvoiceClosed &&
      resultInvoiceClosed?.length > 0 &&
      resultInvoiceClosed.map((item) => item.statmentId);
    viewInvoiceDataInvoiceStatement =
      viewInvoiceBrokerDetail.dataInvoiceStatement &&
      viewInvoiceBrokerDetail.dataInvoiceStatement?.length > 0 &&
      viewInvoiceBrokerDetail.dataInvoiceStatement.filter((item) =>
        statmentIds.includes(item.BillingStatementID)
      );
      if(statmentIds && statmentIds.length > 0){
        couuntAdminCreated = statmentIds.filter(num => num == 0).length;
      }
  }

  if (viewInvoiceStatus == 0) {
    const brokersNames =
      viewInvoicePeriod.notYetStartedDetail.BrokersName.split(",").map((name) =>
        name.trim()
      );
    const brokerIDs = viewInvoicePeriod.notYetStartedDetail.BrokerID.split(
      ","
    ).map((id) => id.trim());

    console.log("brokersNames", brokersNames);
    console.log("brokerIDs", brokerIDs);

    const result = brokerIDs.map((id, index) => ({
      BrokerID: parseInt(id, 10),
      BrokerName: brokersNames[index],
    }));

    viewInvoiceDataInvoiceStatement = result;
  }

  // Define the status constants
  let Invoiceobj = [
    { id: 0, value: "Not Started" },
    { id: 1, value: "Statement Pending" },
    { id: 2, value: "Statement Ready" },
    { id: 3, value: "Invoice Started" },
    { id: 4, value: "Invoice Closed" },
  ];

  // const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Dialog
        className="user-filter-popup invoice-count-filter"
        sx={{ maxWidth: "100%" }}
        fullScreen={fullScreen}
        open={open}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 34px", pb: "8px" }}
          direction="row"
          alignItems="center"
          spacing={1}
          justifyContent="space-between"
        >
          <Typography className="model-title">
            {" "}
            {viewInvoicePeriod.ProjectName} - Billing Period (
            {moment.utc(viewInvoicePeriod.BillingStart).local().format("MM/DD/YYYY")} -{" "}
            {moment.utc(viewInvoicePeriod.BillingEnd).local().format("MM/DD/YYYY")})
          </Typography>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <Typography>
            <span
              className={
                viewInvoiceStatus == 0
                  ? "invoice-popover-chip not-started"
                  : viewInvoiceStatus == 1
                  ? "invoice-popover-chip invoice-ready"
                  : viewInvoiceStatus == 2
                  ? "invoice-popover-chip invoice-open"
                  : viewInvoiceStatus == 3
                  ? "invoice-popover-chip invoice-started"
                  : "invoice-popover-chip invoice-closed"
              }
            >
              {Invoiceobj.find((item) => item.id === viewInvoiceStatus)?.value}
            </span>

            <span
              className={
                viewInvoiceStatus == 0
                  ? "not-started"
                  : viewInvoiceStatus == 1
                  ? "invoice-ready"
                  : viewInvoiceStatus == 2
                  ? "invoice-open"
                  : viewInvoiceStatus == 3
                  ? "invoice-started"
                  : "invoice-closed"
              }
            >
              {viewInvoiceDataInvoiceStatement && viewInvoiceDataInvoiceStatement.length > 0 ? viewInvoiceDataInvoiceStatement.length : 0}
            </span>
          </Typography>
          <TableContainer
            sx={{ mt: "27px", height: "100%", maxHeight: "400px" }}
            className="invoice-filter-table"
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ minWidth: "100px" }}>Broker ID:</TableCell>
                  <TableCell>Broker Name:</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {viewInvoiceDataInvoiceStatement &&
                  viewInvoiceDataInvoiceStatement.map((row, index) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.BrokerID}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.BrokerName}
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  {Array.from({ length: couuntAdminCreated }).map((_, i) => (
                    <TableRow
                    key={i}
                    sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    }}
                    >
                      <TableCell component="th" scope="row">
                        --
                      </TableCell>
                      <TableCell component="th" scope="row">
                        Admin-Generated
                      </TableCell>
                    </TableRow>
                  ))}
                    

              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", pt: "16px" }}
        >
          <Button
            className="filter-btn"
            onClick={() => setViewInvoiceBrokerModel(false)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
